import { ReactNode } from 'react';
import { FC } from 'react';
import React from 'react';
import { Blanket } from './Blanket.js';
import styles from './Dropdown.module.scss';
import { Menu } from './Menu.js';

interface Props {
  isOpen: boolean;
  target: React.ReactNode;
  onClose: () => void;
  children?: ReactNode;
}

export const Dropdown: FC<Props> = ({ children, isOpen, target, onClose }) => (
  <div className={styles.dropdown}>
    {target}
    {isOpen ? <Menu className={styles.menu}>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
